// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoPanel_container__NYL6d","link":"InfoPanel_link__3zHF9"};